<script>
import { onMount } from 'svelte';
import { Firestore, FirebaseAuth as auth } from '../config/firebase';
import Input from './Input.svelte';
import Button from './Button.svelte';

let days = [];
let subscribers = {};
let uid;
let email = '';
let password = '';
let authErrorCode;
let authErrorMessage;

onMount(() => {
  if (auth.currentUser) {
    uid = auth.currentUser.uid;
    loadData();
  } else {
    auth.onAuthStateChanged(function(user) {
      if (user) {
        uid = user.uid;
        loadData();
      }
    });
  }
});

function signIn(evt) {
  // stop the browser to submit the form
  if (evt.preventDefault) {
    evt.preventDefault();
  }

  auth.signInWithEmailAndPassword(email, password)
    .catch(function(error) {
      // Handle Errors here.
      authErrorCode = error.code;
      authErrorMessage = error.message;
    });

}

function loadData() {
  Firestore
    .collection('marketdays-users')
    .onSnapshot(docsSnap => {
      if (docsSnap.docs && docsSnap.docs.length) {
        subscribers = {};
        docsSnap.docs.forEach(doc => {
          subscribers[doc.id] = doc.data();
        });
      }
    });

  Firestore
    .collection('marketdays')
    .onSnapshot(docsSnap => {
      if (docsSnap.docs && docsSnap.docs.length) {
        days = [];
        docsSnap.docs.forEach(doc => {
          const data = doc.data();
          const times = [];
          Object.keys(data).forEach(time => {
            // get bookings data
            const bookings = [];
            let left = data[time].seats;
            if (data[time].bookings) {
              Object.keys(data[time].bookings).forEach(email => {
                let names = 'N / A';
                let company = 'N / A';
                if (subscribers[email]) {
                  names = subscribers[email].firstName + ' ' + subscribers[email].lastName;
                  company = subscribers[email].company;
                }
                left -= data[time].bookings[email];
                bookings.push({
                  names,
                  email,
                  company,
                  persons: data[time].bookings[email]
                });
              });
            }

            times.push({
              time,
              left,
              ...data[time],
              bookings
            });
          })

          days.push({
            date: doc.id,
            times
          });
        });
      }
    });

};


const tableHeadings = ['Names', 'Email', 'Company', 'Persons'];
const tableHeader = ['Date', 'Time', ...tableHeadings];
const tableKeys = ['date', 'time', 'names', 'email', 'company', 'persons'];

function downloadHandler(date) {
  const day = days.find(d => d.date === date);
  if (day) {
    // generate table
    const tableData = [];
    // headeing row
    const header = tableHeader.map(header => ({ value: header, type: 'string' }))
    // data
    const data = [];
    day.times.forEach(timeObj => {
      const time = timeObj.label || timeObj.time;
      if (timeObj.bookings && timeObj.bookings.length) {
        timeObj.bookings.forEach(booking => {
          data.push([
            { value: date, type: 'string' },
            { value: time, type: 'string' },
            { value: booking.names, type: 'string' },
            { value: booking.email, type: 'string' },
            { value: booking.company, type: 'string' },
            { value: booking.persons, type: 'number' }
          ]);
        });
      } else {
        data.push([
          { value: date, type: 'string' },
          { value: time, type: 'string' },
          { value: 'No bookings', type: 'string' }
        ]);
      }
    });

    zipcelx({
      filename: `bookings-${date}.xlsx`,
      sheet: {
        data: [ header, ...data ]
      }
    });
  }
}
</script>

<svelte:head>
  <script src="https://cdn.jsdelivr.net/npm/zipcelx@1.6.2/lib/standalone.js"></script>
</svelte:head>
<div class="container">
  <h1>Bookings for Esch 2022: Open Market Days</h1>

  {#if uid}
    <table class="bookings-table" cellspacing="0">
      <thead>
        {#each tableHeadings as heading}
          <th class="small">{heading}</th>
        {/each}
      </thead>
      {#each days as day}
        <tbody>
          <tr>
            <th colspan="3" class="date">{day.date}</th>
            <th class="date btn"><u on:click|preventDefault={() => downloadHandler(day.date)}>Download in Excel</u></th>
          </tr>
          {#each day.times as time}
            <tr>
              <th colspan="4" class="time">{time.label || time.time} &nbsp; <span>({time.left} seats left)</span></th>
            </tr>
            {#if time.bookings && time.bookings.length}
              {#each time.bookings as booking}
                <tr>
                  <td>{booking.names}</td>
                  <td>{booking.email}</td>
                  <td>{booking.company}</td>
                  <td>{booking.persons}</td>
                </tr>
              {/each}
            {:else}
              <tr>
                <td colspan="4">No bookings</td>
              </tr>
            {/if}
          {/each}
        </tbody>
      {/each}
    </table>
  {:else}
    <form action="" on:submit={signIn}>
      <Input type="email" name="email" bind:value={email} mandatory={true} label="Email" />
      <Input type="password" name="password" bind:value={password} mandatory={true} label="Password" />
      {#if authErrorMessage}
        <div class="error">{authErrorMessage}</div>
      {/if}
      <Button label="Sign In" />
    </form>
  {/if}
</div>

<style>
.container {
  display: flex;
  flex-direction: column;
  margin: 6rem auto;
  max-width: 1200px;
  padding: 3rem;
  background-color: #ffffff;
}

form {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.error {
  color: red;
}

th {
  text-align: left;
}
th.small {
  font-size: 1.3rem;
  font-weight: 300;
}
th.date {
  padding-top: 1.4rem;
  padding-bottom: 0.8rem;
  border-bottom: 2px solid #333;
}
th.date.btn {
  text-align: right;
}
th.date.btn u {
  cursor: pointer;
  font-weight: 400;
}
th.time {
  padding-top: 1rem;
  font-size: 1.6rem;
  border-bottom: 1px solid #666;
}
th.time span {
  font-weight: 500;
}

td {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #999;
}
</style>